<div class="theme-border table-wrapper">
    <table [class.!border-t-0]="!options()?.header?.show">
        <thead>
            <tr>
                @for (column of columns(); track $index) {
                    <th
                        gridColumn
                        [(align)]="align"
                        [(orderBy)]="orderBy"
                        [(selecteds)]="selecteds"
                        [(filters)]="filters"
                        [column]="column"
                        [showHeaderOption]="showHeaderOption()"
                        [class.open-menu]="
                            showHeaderOption() &&
                            column.field !== 'checkbox' &&
                            column.field !== 'rowNumber'
                        "
                        class="theme-text"
                        [ngClass]="{
                            'left-0 sticky z-10 bg-dark-surface border-r':
                                column.type === 'checkbox',
                        }"
                    ></th>
                }
            </tr>
        </thead>
        <tbody
            cdkDropList
            [cdkDropListData]="rowData()"
            (cdkDropListDropped)="handleDragDrop($event)"
            [cdkDropListDisabled]="!dragDrop()?.enable"
        >
            @for (row of rowData(); track $index) {
                <tr
                    animate.enter="fade-in"
                    gridRow
                    cdkDrag
                    class="theme-text group"
                    [class.cursor-pointer]="options()?.row?.clickHandler"
                    [columns]="columns()!"
                    [row]="row"
                    [(selecteds)]="selecteds"
                ></tr>
            }

            @if (!rowData() || rowData()?.length === 0) {
                <tr class="hover:bg-transparent">
                    <td
                        [attr.colspan]="columns()?.length"
                        class="text-center theme-text"
                    >
                        <p class="py-[5rem]">검색 결과를 찾을 수 없습니다.</p>
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>
